module.exports = __webpack_public_path__ + "img/thumb_2020-04.eb8d5e3c.jpg";